(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/xorWith', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/xorWith'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.xorWith, global.convert);
    global.xorWith = mod.exports;
  }
})(this, function (exports, _xorWith2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.xorWith = undefined;

  var _xorWith3 = _interopRequireDefault(_xorWith2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.xor} except that it accepts <code>comparator</code> to compare elements.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} arrays The arrays to inspect.
   * @param {Function} [comparator] The comparator invoked per element.
   * @return {Object} Returns the updated object.
   * @example xorWith({ nested: { prop: [{ x: 1 }, { x: 2 }] } }, 'nested.prop', [{ x: 2 }, { x: 3 }], (a, b) => a.x === a.b) // => { nested: { prop: [{ x: 1 }, { x: 3 }] } }
   * @see {@link https://lodash.com/docs#xorWith|lodash.xorWith} for more information.
   * @since 0.3.0
   */
  var xorWith = (0, _convert.convert)(_xorWith3.default);
  exports.xorWith = xorWith;
  exports.default = xorWith;
});